import { AdvComModule, JkgridwinComponent, JkrangeComponent } from 'jk-advcom';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { UiModeType, PageKind, } from 'jk-service';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { StkwlService } from '../services/Stkwl.service';
import { StkwlEditComponent } from '../stkwl-edit/stkwl-edit.component';



@Component({
  selector: 'app-stkpi01-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './stkpi01-detail.component.html',
  styleUrls: [],
})
export class Stkpi01DetailComponent extends jkSingleComponent implements OnInit {
    @ViewChild('stkwl005') stkwl005!: JkrangeComponent;
    override _programId = 'stkpi01-detail';
  constructor() {
    super();
    this.srv = new StkwlService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.masterEditPage = StkwlEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'WL005', sort: 'desc', defaultSort: null, pageKind: this.pageKind };
    this.srv.programId = 'stock'; // ### modi,不要亂改

    this.srv.linkMasterFields = 'WL001=MA001';// ### modi,不要亂改
    
    //this.constructorInit(); // ###

  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    this.srv.cdr = this.cdr;
  };

  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.setMasterService();
  }
  // 客製開始====================================================
  stkwl005_1: string = '';
  stkwl005_2: string = '';
  stkwlGrid!: JkgridwinComponent;
  //stkwl: StkwlService = new StkwlService();

  afterGridReadyStkwl($event: JkgridwinComponent) {
    this.stkwlGrid = $event;
    //this.stkwlGrid.initPage(this);
  }
  async doQueryStkwl() {
    let order = ' WL008 DESC,WL005 DESC,WL001 DESC,WL002 DESC ';
    let where = ` AND WL010<>'' AND WL001=WL010 `; // this.stklg.sqlWhereDefault;
    try {
      where = this.stkwl005.addWhere(where, 'WL005');

    } catch (error: any) {
      alert('doQuery:' + error.message);
      return;
    }
    // this.stklgGrid.order = this.stklg.sqlOrderDefault;
    //await this.qryMaster.getopenwin(openWinIn,this.ret);
    this.stkwlGrid.doQuery2('STKWL', 'S02', 'S', where, order); // init('STKLG', 'V02', 'S', ['LG001', 'LG002', 'LG003', 'LG004'], [this.filterOpt.date1, this.filterOpt.date2, this.filterOpt.stklg002, this.pageOpt.stkmf002]);
  }
  afterQueryStkwl($event: any) {
    //this.stklgGrid.resort();
    //this.mtrwl.itemList = this.mtrwlGrid.itemList;
    //this.updateChart();
  }

}
